import { render, staticRenderFns } from "./Productpay.vue?vue&type=template&id=5fe312ce&scoped=true"
import script from "./Productpay.vue?vue&type=script&lang=js"
export * from "./Productpay.vue?vue&type=script&lang=js"
import style0 from "./Productpay.vue?vue&type=style&index=0&id=5fe312ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe312ce",
  null
  
)

export default component.exports